export async function fetchAppConfig<Config>(): Promise<Config> {
  const url = (import.meta.env.BASE_URL + '/config.json').replace(/\/\//g, '/')
  const data = await (await fetch(url, { cache: 'no-cache' })).json()
  return data
}
